var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconalertcritical = function SvgIconalertcritical(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Alerts/Critical_Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Alerts/Critical_Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "#EE3B0C",
    transform: "translate(10.000000, 10.000000) rotate(22.000000) translate(-10.000000, -10.000000) ",
    points: "10 -0.785347427 17.6263923 2.3736077 20.7853474 10 17.6263923 17.6263923 10 20.7853474 2.3736077 17.6263923 -0.785347427 10 2.3736077 2.3736077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4795138,5.93771853 C11.4246774,5.37165053 10.7796639,4.92096677 9.96951383,4.88265144 C9.56711889,4.87820285 9.17933416,4.98793227 8.89476236,5.18676826 C8.61019056,5.38560425 8.45314706,5.65655717 8.45951383,5.93771853 L8.45951383,10.5515991 C8.45314706,10.8327605 8.61019056,11.1037134 8.89476236,11.3025494 C9.17933416,11.5013854 9.56711889,11.6111148 9.96951383,11.6066662 C10.7796639,11.5683509 11.4246774,11.1176671 11.4795138,10.5515991 L11.4795138,5.93771853 Z",
    id: "Path_506-3-path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3613455,14.4634858 C11.3809331,13.6048738 10.7217816,12.8773334 9.85134551,12.7968192 C9.41949631,12.8028784 9.010084,12.9867949 8.72295308,13.3037164 C8.43582216,13.620638 8.29736427,14.0414347 8.34134551,14.4634858 L8.34134551,14.4634858 C8.29736427,14.885537 8.43582216,15.3063337 8.72295308,15.6232553 C9.010084,15.9401768 9.41949631,16.1240933 9.85134551,16.1301525 C10.7217816,16.0496383 11.3809331,15.3220979 11.3613455,14.4634858 Z",
    id: "Path_506-3-path",
    fill: "#FFFFFF"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconalertcritical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.alert.critical.55171f30b872f53f7de551000bf49db0.svg";